import { DashboardRenderer } from '../../components/dashboard'

export function AdvisorDashboard() {
  return <DashboardRenderer dashboardKey="advisor" />
}
